import React from "react";
import Popover from "../../../../../../../../common-deprecated/components/popover/aem/Popover";
import { BnbLabel } from "../../../../../utils/labels";
import { showModal } from "../../../../../../../../common-deprecated/redux/actions/ModalActions";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import Preloader, * as PreloaderStyles from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/Preloader";
import useETA from "../../../../../hooks/shared/useETA";
import type { BuildAndBuyDispatchType } from "../../../../../redux/store";
import { MODAL_ALTERNATIVES_ETA } from "../../../../../utils/modalConstants";
import ETADeliveryLabel from "../../ETADeliveryLabel";
import { IconWrapper } from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import * as Styles from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/basket/Basket";
import { trackEtaOpen } from "../../../../../utils/tracking";
import useETADeliveryLabel from "../../../../../hooks/shared/useETADeliveryLabel";
import { useDispatch } from "../../../../../../../../shared-logic/redux/store";

const BasketETA = (): JSX.Element | null => {
    const { show, loading, date, disclaimer } = useETA();
    const etaDeliveryLabel = useETADeliveryLabel(date);
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    if (!show) return null;
    if (loading)
        return (
            <PreloaderStyles.PreLoaderWrapper mt={4} mb={5} data-testid="basket-eta-loader">
                <Preloader size={30} />
            </PreloaderStyles.PreLoaderWrapper>
        );
    if (!etaDeliveryLabel) return null;

    return (
        <Styles.EtaWrapper>
            <Styles.EtaHeader>
                <ETADeliveryLabel date={date} />
                {disclaimer && <Popover showOnClick content={disclaimer} />}
            </Styles.EtaHeader>
            <Button.Link
                hasIconRight
                large
                onClick={() => {
                    trackEtaOpen();
                    dispatch(showModal({ type: MODAL_ALTERNATIVES_ETA }));
                }}
            >
                <Text.Button>
                    <BnbLabel label="earlierAvailableCars" />
                </Text.Button>
                <IconWrapper>
                    <Icon variant="arrowRight" />
                </IconWrapper>
            </Button.Link>
        </Styles.EtaWrapper>
    );
};

export default BasketETA;
